import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "~/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-[var(--radius-pill)] px-2 py-0.5 text-[11px] font-semibold leading-[1.4] [&_svg]:size-3",
  {
    variants: {
      tone: {
        default: "bg-bg-subtle text-fg-2",
        primary: "bg-primary-50 text-primary-700",
        "score-a": "bg-score-a-bg text-score-a",
        "score-b": "bg-score-b-bg text-[#B25612]",
        "score-c": "bg-score-c-bg text-score-c",
        "status-processing": "bg-status-processing-bg text-[#1F7A77]",
        "status-review": "bg-score-b-bg text-[#B25612]",
        "status-approved": "bg-score-a-bg text-score-a",
        "status-published": "bg-primary-50 text-primary-700",
        "status-draft": "bg-status-draft-bg text-[#5E3884]",
      },
    },
    defaultVariants: {
      tone: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ className, tone, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ tone }), className)} {...props} />
));
Badge.displayName = "Badge";

export { badgeVariants };
